<span *ngIf="disabled">{{ display }}</span>
<!--<div class="mr-6">{{ displaySGTime }}</div>-->

<input
  (click)="picker.open()"
  (dateChange)="addEvent('change', $event)"
  (dateInput)="addEvent('input', $event)"
  [class.field-invalid]="showError"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [id]="id"
  [matDatepicker]="picker"
  [max]="props.maxDate ? props.maxDate : null"
  [min]="props.minDate ? props.minDate : null"
  [name]="field.name"
  [placeholder]="props.placeholder"
  [portalCyTest]="field.key"
  [readonly]="true"
  [required]="props.required || false"
  [tabIndex]="props.tabindex"
  [type]="type"
  class="field-input"
/>

<mat-datepicker-toggle
  *ngIf="!disabled"
  [disableRipple]="true"
  [disabled]="disabled"
  [for]="picker"
  [portalCyTest]="field.key + '_picker'"
>
  <mat-icon
    matDatepickerToggleIcon
    svgIcon="calendar"
    >keyboard_arrow_down
  </mat-icon>
</mat-datepicker-toggle>

<mat-datepicker #picker></mat-datepicker>
